import { render, staticRenderFns } from "./SettingsWrapper.vue?vue&type=template&id=72123876&scoped=true&"
import script from "./SettingsWrapper.vue?vue&type=script&lang=ts&"
export * from "./SettingsWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsWrapper.vue?vue&type=style&index=0&id=72123876&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72123876",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
